import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { MdArrowBack } from "react-icons/md";
import AppTable from "../../shared/AppTable";
import claimsGQL from "../../gql/claims";
import TableSkeletonLoader from "../../common/TableLoading";

function ClaimErrorList() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const navigate = useNavigate();
  const location = useLocation();
  const { filterInput, errorDetails } = location.state || {};

  const [errorList, setErrorList] = useState([]);
  const [total, setTotal] = useState(0);

  const { loading, data } = useQuery(claimsGQL.GET_ERRORS_LIST_FOR_CLAIMS, {
    variables: {
      input: filterInput,
    },
    skip: !filterInput,
  });

  useEffect(() => {
    if (data?.getErrorsListForClaims) {
      setErrorList(data.getErrorsListForClaims.data || []);
      setTotal(data.getErrorsListForClaims.total || 0);
    }
  }, [data]);

  const FormatDate = (date) => {
    if (!date) return "---";
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(new Date(date));
  };

  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) => index + 1,
    },
    { header: t("Patient Name"), field: "patient_name" },
    { header: t("Payer Name"), field: "payer_name" },
    {
      header: t("Date Ordered"),
      render: (row) => FormatDate(row?.date_ordered),
    },
    { header: t("Transaction ID"), field: "transaction_id" },
    {
      header: t("TPA Name"),
      render: (row) => row?.tpa_name || "---",
    },
  ];

  return (
    <div className="">
      {/* Header */}
      <div className=" flex items-start gap-2">
        <div
          onClick={() => navigate(-1)}
          className="bg-[#0070C2] hover:bg-[#0070C2]/80 cursor-pointer rounded-full p-1"
        >
          <MdArrowBack
            className={
              isRTL ? "text-white h-4 w-4 rotate-180" : "text-white h-4 w-4 "
            }
          />
        </div>
        <div>
          <Typography
            sx={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}
          >
            {t("Claims for Error")}: {errorDetails?.error_code}
          </Typography>
          <Typography variant="caption" className="text-slate-500 font-medium">
            {errorDetails?.error_message}
          </Typography>
        </div>
      </div>

      {/* Content */}
      <div className="mt-1">
        <AppTable
          columns={columns}
          data={errorList}
          loading={loading}
          onView={(row) => {
            navigate("/claims/details", {
              state: { currentItem: { transaction_id: row.transaction_id } },
            });
          }}
          LoaderComponent={
            <TableSkeletonLoader columnCount={columns.length} rowCount={10} />
          }
        />
      </div>
    </div>
  );
}

export default ClaimErrorList;
